import React from 'react'
import { Button } from '@mui/material'
import './index.scss'

import { useTranslation } from 'react-i18next'
import ChildPageHeader from '@/components/UI/ChildPageHeader'
import { useQuizImport } from '@/hooks/useQuizImport'
import DocumentUploadSection from '@/components/Quizzes/DocumentUploadSection'
import QuizImportInstructions from '@/components/Quizzes/QuizImportInstructions'

const ImportQuiz: React.FC = () => {
  const { t } = useTranslation('translation')
  const {
    documents,
    isFileUploading,
    handleFileSelection,
    handleFileRemove,
    handleImport,
  } = useQuizImport({ mode: 'import-quiz' })

  return (
    <section className="page-mid-wraper h-without-foter">
      <ChildPageHeader
        title={t('Import Quiz')}
        subTitle={t('Upload a document with questions to create a new quiz')}
        slot={{
          action: (
            <Button
              variant="contained"
              size="medium"
              disabled={isFileUploading}
              onClick={handleImport}
            >
              {t('Import Quiz')}
            </Button>
          ),
        }}
      />

      <div className="upload-document-page-container add-faq-container">
        <div className="page-content-container">
          <div className="mb-3">
            {t(
              'Upload a document with quiz questions and answers in any format. The questions will be extracted from the uploaded document and you can edit them in the next screen.',
            )}
          </div>

          <QuizImportInstructions />

          <DocumentUploadSection
            documents={documents}
            onFilesSelected={files =>
              handleFileSelection(files, 'customtemplates')
            }
            onFileRemove={handleFileRemove}
            isUploading={isFileUploading}
            supportedTypes=".docx, .txt, .pdf"
          />
        </div>
      </div>
    </section>
  )
}

export default ImportQuiz
